import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { useProfileStore } from "@/stores"

export interface AvatarBaseProps {
  size?: "sm" | "md" | "lg"
}

const sizeClasses = {
  sm: "h-8 w-8",
  md: "h-10 w-10",
  lg: "h-16 w-16"
}

export default function AvatarBase({ size = "md" }: AvatarBaseProps) {
  const { profile } = useProfileStore()

  return (
    <Avatar className={sizeClasses[size]}>
      <AvatarImage src={profile?.avatar_url || undefined} alt={profile?.name || "User avatar"} />
      <AvatarFallback>
        {profile?.name?.charAt(0)?.toUpperCase()}
      </AvatarFallback>
    </Avatar>
  )
}